/**
 * Module-level auth token getter.
 *
 * In production, ClerkTokenBridge (rendered inside ClerkProvider) calls
 * setTokenGetter() with Clerk's getToken function.
 *
 * In local dev without Clerk, the fallback returns the dev token. Resolution
 * order: localStorage (DevUserSwitcher writes here) → VITE_DEV_AUTH_TOKEN →
 * the literal string "dev-user". localStorage wins so testers can switch
 * test identities without a Vite restart.
 *
 * Both api-client.ts (ky beforeRequest) and SSE hooks use getAuthToken().
 */

export const LOCAL_DEV_AUTH_KEY = "paperchase-dev-auth-id";

let _getToken: (() => Promise<string | null>) | null = null;

export function setTokenGetter(fn: () => Promise<string | null>) {
  _getToken = fn;
}

export function readDevAuthId(): string {
  if (typeof window !== "undefined") {
    try {
      const stored = window.localStorage.getItem(LOCAL_DEV_AUTH_KEY);
      if (stored) return stored;
    } catch {
      // ignore — Safari private mode etc.
    }
  }
  return import.meta.env.VITE_DEV_AUTH_TOKEN ?? "dev-user";
}

export async function getAuthToken(): Promise<string> {
  if (_getToken) {
    return (await _getToken()) ?? "";
  }
  return readDevAuthId();
}
